export enum EnumPerfiles {
    CallCenter = 1,
    Comercial = 2,
    Analista = 3,
    Tecnico = 4,
    Gerente = 5,
    Planeador = 7,
    TecnicoNBS = 8,
    VerificadorCalidad = 9,
    AdministradorCalidad = 10
}